import { predefinedRoles } from '../rolesConfig/predefinedRolesConfig';
import { PredefinedAreaRole, PredefinedRole, Role, RolesArea, RolesData } from '../types/roles';
import { i18nInstance } from '../i18n';

export const getPredefinedAreas = (predefinedRolesDTO: PredefinedAreaRole[] = predefinedRoles): PredefinedAreaRole[] =>
  predefinedRolesDTO;

export const getPredefinedRoles = (predefinedRolesDTO: PredefinedAreaRole[] = predefinedRoles): PredefinedRole[] => {
  const roles = predefinedRolesDTO.map(area => area.roles).flat();
  if (process?.env?.NODE_ENV === 'test') {
    filterPropertiesForTestEnv(roles);
  }
  return roles;
};

const filterPropertiesForTestEnv = (roles): void =>
  roles.forEach(role => {
      delete role.restrictFromLevel;
      delete role.deprecated;
      delete role.appDefIds;
      delete role.experiments;
});

export const createRoleAreas = (rolesData: RolesData, predefinedRolesDTO: PredefinedAreaRole[]): RolesArea[] => {
  const { roles, customRoles } = getPredefinedAndCustomRolesData(rolesData);
  let rolesByAreas = createCustomRolesArea(customRoles);
  return rolesByAreas.concat(createPredefinedRoleAreas(roles, predefinedRolesDTO));
};

const getPredefinedAndCustomRolesData = (roles: Role[]): { roles: Role[], customRoles: Role[] } =>
  roles.reduce((predefinedAndCustomRoles , role) => {
    if (role.isCustom)  {
      predefinedAndCustomRoles.customRoles.push(role);
    } else {
      predefinedAndCustomRoles.roles.push(role);
    }
    return predefinedAndCustomRoles;
  }, { roles: [], customRoles: [] });

const createPredefinedRoleAreas = (roles: Role[], predefinedRolesDTO: PredefinedAreaRole[]): RolesArea[] => {
  return getPredefinedAreas(predefinedRolesDTO).map(_area => {
    const newRoles = _area.roles.map(role => roles.find(_role => _role.id === role.id)).filter(_role => _role);
    if (newRoles.length > 0) {
      return {
        title: i18nInstance.t(_area.titleKey),
        roles: Array.from(new Set(newRoles)),
      };
    } else {
      return null;
    }
  }).filter(_area => _area);
};

const createCustomRolesArea = (customRoles: Role[]): RolesArea[] => {
  return [{
    title: i18nInstance.t('role.area.title.custom'),
    roles: customRoles,
  }];
};

export const isBookingsStaffMember = (roleId: string): boolean =>
  roleId === '6600342952117491717';
